import { useEffect, useState } from "react";

const REFRESH_TIME_MILLISECONDS = 10 * 1000;
const MILLISECONDS_TO_MINUTES = 1000 * 60;
const MILLISECONDS_TO_HOURS = MILLISECONDS_TO_MINUTES * 60;
const MILLISECONDS_TO_DAYS = MILLISECONDS_TO_HOURS * 24;

type CountDownResult = {
    days: number;
    hours: number;
    minutes: number;
}
/**
 * Hook que devuelve los días, horas y minutos que faltan 
 * para determinada fecha a partir de la fecha actual.
 *  */
export function useCountDown(finalDate?: string) {
    const [finalDateObj] = useState<Date | undefined>(parseDate(finalDate));   
    const [diff, setDiff] = useState<CountDownResult>(calculateDateDiff(finalDateObj));
    const validDate: boolean = (finalDateObj != undefined);

    useEffect( () => {
        let interval: NodeJS.Timeout | undefined = undefined;       

        if(finalDateObj && finalDateObj > (new Date())) {
            interval = setInterval( 
                () => {  
                        const currentDiff = calculateDateDiff(finalDateObj);
                        if(diff.days != currentDiff.days 
                            || diff.hours != currentDiff. hours 
                            || diff.minutes != currentDiff.minutes){
                                setDiff(currentDiff);                                
                        }
                },
                REFRESH_TIME_MILLISECONDS );
        }        
        return () => interval && clearInterval(interval);
    }, [finalDateObj, diff, setDiff])

    return [validDate, diff.days, diff.hours, diff.minutes] as const;
}

function parseDate( dateStr?: string ): Date | undefined {
    let dateObj: Date | undefined = undefined; 

    if(!dateStr || dateStr.trim().length === 0)
        return undefined;

    try{
        dateObj = new Date(dateStr);
    }catch(e: any) {}

    if(!dateObj || Number.isNaN(dateObj.valueOf()))
        return undefined;

    return dateObj;
}

function getCountdownFromMillis(millis: number){
    const days = Math.floor(millis/MILLISECONDS_TO_DAYS);
    const hours = Math.floor((millis - days * MILLISECONDS_TO_DAYS) / MILLISECONDS_TO_HOURS);
    const minutes = Math.floor((millis - days * MILLISECONDS_TO_DAYS - hours * MILLISECONDS_TO_HOURS ) / MILLISECONDS_TO_MINUTES)
   
    return { days: days, hours: hours, minutes: minutes}    
}

const ZERO_TIME: CountDownResult = {days: 0, hours: 0, minutes: 0};

function calculateDateDiff(finalDate: Date | undefined){
    if(!finalDate)
        return ZERO_TIME;
    
    const diffMilliseconds = finalDate?.getTime() - (new Date()).getTime();

    if(diffMilliseconds <= 0)
        return ZERO_TIME;
    
    return getCountdownFromMillis(diffMilliseconds);
}
